/**
 * Usage:
 *
 * data-sw-product-slideshow=<productSpin>
 *
 */

var $ = require('./../sw-jquery');

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-product-images-table]').each(function() {
    var $el = $(this);

    require([
      './../../lib/models/ModelManager',
      './../../lib/views/ProductImagesTable'
    ], function(ModelManager, ProductImagesTable) {

      var spin = $el.data('swProductImagesTable');
      var product = ModelManager.getProduct(spin);

      new ProductImagesTable({
        el:     $el,
        model:  product
      });

    });
  });

};
